module.exports = __webpack_public_path__ + "img/destinations-asia.7ad3e2cf.webp";